export default "__VITE_PUBLIC_ASSET__081e64b7__"